import { render, staticRenderFns } from "./pufaPrivacyAgreement.vue?vue&type=template&id=25bf5d45&scoped=true"
import script from "./pufaPrivacyAgreement.vue?vue&type=script&lang=js"
export * from "./pufaPrivacyAgreement.vue?vue&type=script&lang=js"
import style0 from "./pufaPrivacyAgreement.vue?vue&type=style&index=0&id=25bf5d45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bf5d45",
  null
  
)

export default component.exports